module.exports = __webpack_public_path__ + "static/img/e_bcg2.dd2ddf23.png";